import styled from 'styled-components';

import Icon from 'components/Icon';

import {commonPalette} from 'styles/palette';

export const PasswordCheck = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  background-color: ${({checked}) => (checked ? commonPalette.brightGreen : commonPalette.disabledText)};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;

export const CheckWrapper = styled.div`
  display: flex;
  margin: 10px 0 10px 15px;
`;

export const StyledIcon = styled(Icon).attrs({
  style: {
    color: commonPalette.white,
    fontSize: 4
  }
})`
  width: ${({name}) => (name === 'close' ? 10 : 18)}px;
  height: ${({name}) => (name === 'close' ? 10 : 18)}px;
`;

export const PasswrodChecklistWrapper = styled.div`
  margin: 15px 0px 25px;
`;
